import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import { ConnectedProps } from 'mf-shared/types/common';

import styles from './style.css';

function mapStateToProps(state) {
  return {
    formRegState: state.moka.formRegState,
  };
}

const connector = connect(mapStateToProps);

interface RegisterCompleteProps {}

interface RegisterCompleteState {}

type Props = ConnectedProps<typeof connector, RegisterCompleteProps>;

class RegisterComplete extends React.Component<Props, RegisterCompleteState> {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { formRegState } = this.props;

    return (
      <div className="container">
        <div className="row" id="registerComplete">
          <div className="col-md-2">&nbsp;</div>
          <div className="col-md-8" id="all-set">
            <h2 className={`${styles.title}`}>Hi, Welcome on board!</h2>
            <br />
            <div className={`col-xs-12 no-padding ${styles.text}`}>
              <p>
                Thanks for signing up with Moka. Just verify your email address
                and you're all ready to set up your own outlet.
              </p>
            </div>
            <div className={`col-xs-12 no-padding`}>
              <hr className={`col-xs-12 no-padding ${styles.splitter}`} />
              <div className={`col-xs-12 no-padding text-center`}>
                <img
                  className={`${styles['img-progress']}`}
                  src="https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/register/1+more+step.png"
                />
              </div>
              <hr className={`col-xs-12 no-padding ${styles.splitter}`} />
            </div>

            <div className={`col-xs-12 no-padding ${styles.text}`}>
              <h2 className={`${styles.title}`}>Verify Your Account</h2>
              <br />
              <p>
                Check{' '}
                <b>
                  {formRegState.email
                    ? formRegState.email
                    : 'your.email@website.com'}
                </b>{' '}
                and click on the link we sent to you.
              </p>
              <br />
              <br />
              <p>
                Haven't received our email?{' '}
                <Link
                  className={`${styles.link}`}
                  activeClassName={`${styles.link}`}
                  to="/resend"
                >
                  Resend email.
                </Link>
              </p>
            </div>
          </div>
          <div className="col-md-2">&nbsp;</div>
          <div className="clear" />
        </div>
      </div>
    );
  }
}

export default connector(RegisterComplete);
